/* eslint-disable @typescript-eslint/naming-convention */
export enum CategoryOrAnd {
	Or = "カテゴリ間の条件をorで設定する",
	And = "カテゴリ間の条件をandで設定する",
}
